import type { z } from 'zod';

import type { CourseSchema } from './schemas';

type CourseField = keyof z.infer<typeof CourseSchema>;

const listAttributes = [
  'id',
  'subject',
  'label',
  'shortLabel',
  'grade',
] as const satisfies readonly CourseField[];

// The billing values are read, never written: a course state no class governs is priced by
// them, and nothing else is
const getAttributes = [
  ...listAttributes,
  'terms',
  'creditsPerTerm',
  'xeroCodes',
] as const satisfies readonly CourseField[];

const updateAttributes = ['label', 'shortLabel'] as const satisfies readonly CourseField[];

export const CourseAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
